/**
 * Сервис для управления уникальным идентификатором пользователя
 * Генерирует и сохраняет уникальный ID пользователя в localStorage
 */

const USER_ID_KEY = 'plinus_user_id';
const ANALYSIS_COUNTER_KEY = 'plinus_analysis_counter';

/**
 * Генерирует случайный идентификатор пользователя длиной 10 символов
 * Использует буквы (a-z, A-Z) и цифры (0-9)
 */
function generateUserId(): string {
  const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let result = '';
  for (let i = 0; i < 10; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

/**
 * Получает уникальный идентификатор пользователя
 * Если ID не существует, генерирует новый и сохраняет в localStorage
 */
export function getUserId(): string {
  try {
    let userId = localStorage.getItem(USER_ID_KEY);
    
    if (!userId) {
      userId = generateUserId();
      localStorage.setItem(USER_ID_KEY, userId);
      console.log('🆔 Сгенерирован новый ID пользователя:', userId);
    }
    
    return userId;
  } catch (error) {
    console.error('Ошибка при получении ID пользователя:', error);
    // Fallback - генерируем ID без сохранения
    return generateUserId();
  }
}

/**
 * Получает текущий счетчик анализов
 * Если счетчик не существует, инициализирует его значением 0
 */
export function getAnalysisCounter(): number {
  try {
    const counter = localStorage.getItem(ANALYSIS_COUNTER_KEY);
    return counter ? parseInt(counter, 10) : 0;
  } catch (error) {
    console.error('Ошибка при получении счетчика анализов:', error);
    return 0;
  }
}

/**
 * Увеличивает счетчик анализов на 1 и возвращает новое значение
 */
export function incrementAnalysisCounter(): number {
  try {
    const currentCounter = getAnalysisCounter();
    const newCounter = currentCounter + 1;
    localStorage.setItem(ANALYSIS_COUNTER_KEY, newCounter.toString());
    console.log('📊 Счетчик анализов увеличен до:', newCounter);
    return newCounter;
  } catch (error) {
    console.error('Ошибка при увеличении счетчика анализов:', error);
    return getAnalysisCounter() + 1;
  }
}

/**
 * Сбрасывает счетчик анализов (для тестирования)
 */
export function resetAnalysisCounter(): void {
  try {
    localStorage.removeItem(ANALYSIS_COUNTER_KEY);
    console.log('🔄 Счетчик анализов сброшен');
  } catch (error) {
    console.error('Ошибка при сбросе счетчика анализов:', error);
  }
}

/**
 * Проверяет, является ли переданный ID валидным форматом
 * ID должен состоять из 10 символов (буквы и цифры)
 */
export function isValidUserId(userId: string): boolean {
  return /^[a-zA-Z0-9]{10}$/.test(userId);
}

/**
 * Проверяет, является ли переданный номер анализа валидным
 * Номер должен быть положительным числом
 */
export function isValidAnalysisNumber(analysisNumber: string): boolean {
  const num = parseInt(analysisNumber, 10);
  return !isNaN(num) && num > 0;
}
